import React from 'react';
import { Show, SimpleShowLayout, TextField, DateField, BooleanField } from 'react-admin';
import {isAdmin} from "./../../services/LocalStorage";
import CouponsLeftCard from "./CouponsLeftCard";

export const CampaignShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <CouponsLeftCard/>
      <TextField source="id" label="ID"/>
      {isAdmin() && <TextField source="coreShopId" label="Core shop ID"/>}
      <TextField source="title" label="title"/>
      <BooleanField source="active" />
      <BooleanField source="default" />
      <TextField source="defaultCouponCode" label="Default coupon code"/>
      <TextField source="defaultCouponDescription" label="Default coupon description"/>
      <DateField source="startDate" label="startDate"/>
      <DateField source="endDate" label="endDate"/>
    </SimpleShowLayout>
  </Show>
);
